(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/location-api-dialogs.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/location-api-dialogs.js');
"use strict";


const showLocationCoordsError = function () {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _.noop;
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Hoppsan!',
    icon: 'exclamation-sign',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Vi kunde inte hitta din plats. Försök igen senare.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Du kan alltid använda kartan för att välja en plats.'
    }],
    actions: [{
      title: 'Jag förstår',
      callback: () => {
        dialog.close();
        callback();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  showLocationCoordsError
});

 })(window);